import classNames from "classnames";
import styles from "../style.module.scss";
import { useEffect, useState } from "react";
import {
  GetAllTransactions,
  PayoutService,
} from "shared/services/transactions";
import { TransactionType } from "shared/utils/enum";
import CustomPagination from "shared/components/common/customPagination";
import CustomTable from "shared/components/common/customTable";
import CustomToolTip from "shared/components/common/customToolTip";
import SkeletonLoader from "shared/loaders/skeleton";
import { Icons } from "assets";
import ConfirmationModal from "shared/modal/confirmation";
import { handleErrors } from "shared/utils/helper";
const PaymentTransactions = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [selectedTransactions, setSelectedTransactions] = useState<any>();
  const [transferLoading, setTransferLoading] = useState<boolean>(false);

  const openConfirmModal = () => {
    setConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setConfirmModal(false);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleGetAllTransactionns(page);
  };

  const imagesTableHeads = [
    { title: "#", key: "sr" },
    { title: "Product", key: "product" },
    { title: "Transaction Id", key: "id" },
    { title: "Buyer", key: "from_user" },
    { title: "Seller", key: "to_user" },
    { title: "Total", key: "total" },
    { title: "Platform Fee", key: "platform_fee" },
    { title: "Paid Amount", key: "paid_amount" },
    { title: "Payout Status", key: "paid_out" },
    { title: "Action", key: "action" },
  ];

  const handleGetAllTransactionns = async (page: number) => {
    setLoading(true);
    GetAllTransactions({
      page: page,
      limit: 10,
      type: TransactionType.PURCHASE,
    })
      .then(({ status, data: { data } }) => {
        if (status) {
          setTransactions(data?.data);
          setTotalItems(data?.meta?.totalItems);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePayout = () => {
    setTransferLoading(true);
    PayoutService(selectedTransactions?.id)
      .then(({ status, data }) => {
        if (status) {
          let tempArr = transactions?.map((item) =>
            item?.id === selectedTransactions?.id
              ? {
                  ...item,
                  paid_out: true,
                }
              : item
          );
          setTransactions(tempArr);
          closeConfirmModal();
        }
      })
      .catch((err) => {
        handleErrors(err);
      })
      .finally(() => {
        setTransferLoading(false);
      });
  };

  useEffect(() => {
    handleGetAllTransactionns(1);
  }, []);

  return (
    <div className={classNames(styles.sectionContainer)}>
      <div className={classNames(styles.header)}></div>
      <div className={classNames(styles.tableWrapper, "relative")}>
        <CustomTable
          heads={imagesTableHeads}
          title="Transactions"
          isEmpty={!loading && !transactions.length}
        >
          {loading
            ? Array.from({ length: 2 }).map((_, index) => (
                <TableRowLoader key={index} />
              ))
            : transactions.map((data, idx) => (
                <tr key={data.id}>
                  <td>{idx + 1}</td>
                  <td>
                    <div className="flex items-center gap-1">
                      <img
                        src={data?.product?.media?.fullpath}
                        alt={"product photo"}
                        width="100"
                      />
                      <label>{data?.product?.title}</label>
                    </div>
                  </td>
                  <td>{data?.id}</td>
                  <td>{data?.from_user?.name}</td>
                  <td>{data?.to_user?.name}</td>
                  <td>${(data?.total / 100).toFixed(2)}</td>
                  <td>${(data?.platform_fee / 100).toFixed(2)}</td>
                  <td>${(data?.paid_amount / 100).toFixed(2)}</td>
                  <td>
                    {data?.pending
                      ? "Order in Progress"
                      : data?.paid_out
                      ? "paid"
                      : "pending"}
                  </td>
                  <td className="">
                    {!data?.paid_out && !data?.pending ? (
                      <div className={classNames(styles.IconsContainer)}>
                        <CustomToolTip label="Transfer">
                          <button
                            onClick={() => {
                              setSelectedTransactions(data);
                              openConfirmModal();
                            }}
                          >
                            <Icons.Payment />
                          </button>
                        </CustomToolTip>
                      </div>
                    ) : null}
                  </td>
                </tr>
              ))}
        </CustomTable>
      </div>

      <CustomPagination
        onPageChange={handlePageChange}
        totalCount={totalItems}
        currentPage={currentPage}
        pageSize={10}
      />
      {confirmModal && (
        // @ts-ignore
        <ConfirmationModal
          show={confirmModal}
          title="Confirm Payment Transfer"
          actionButtonText="Yes, Trasnfer"
          subtitle={`Are you sure you want to transfer $${(
            selectedTransactions?.paid_amount / 100
          ).toFixed(2)} to ${selectedTransactions?.to_user?.name}`}
          loading={transferLoading}
          handleSubmit={handlePayout}
          handleClose={closeConfirmModal}
        />
      )}
    </div>
  );
};

const TableRowLoader = () => (
  <tr>
    {Array.from({ length: 10 }).map((_, index) => (
      <td
        key={index}
        className={classNames(styles.tableContentLabel, "px-2 py-3")}
      >
        <div className="flex items-center justify-center">
          <SkeletonLoader className={styles.lineLoader} />
        </div>
      </td>
    ))}
  </tr>
);

export default PaymentTransactions;
